"use client";

import * as React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import "@/styles/global.css";

import { appConfig } from "@/config/app";
import { getSettings as getPersistedSettings } from "@/lib/settings";
import { AuthProvider } from "@/components/auth/custom/auth-context";
import { ThemeProvider } from "@/components/core//theme-provider";
import { I18nProvider } from "@/components/core/i18n-provider";
import { LocalizationProvider } from "@/components/core/localization-provider";
import { Rtl } from "@/components/core/rtl";
import { SettingsProvider } from "@/components/core/settings/settings-context";
import { Toaster } from "@/components/core/toaster";

const metadata = { title: appConfig.name };

export function Root({ children }) {
	const settings = getPersistedSettings();

	return (
		<HelmetProvider>
			<Helmet>
				<title>{metadata.title}</title>
				<meta content={appConfig.themeColor} name="theme-color" />
			</Helmet>
			<AuthProvider>
				<LocalizationProvider>
					<SettingsProvider settings={settings}>
						<I18nProvider>
							<Rtl>
								<ThemeProvider>
									{children}
									<Toaster position="bottom-right" />
								</ThemeProvider>
							</Rtl>
						</I18nProvider>
					</SettingsProvider>
				</LocalizationProvider>
			</AuthProvider>
		</HelmetProvider>
	);
}
